import { Location } from '@angular/common';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';

@Component({
    selector: 'build-details',
    templateUrl: './buildDetailsComponent.html'
})
export class BuildDetailsComponent implements OnInit {
    public _baseUrl: any;
    public buildNumber: string = '0';
    public backEndbuildNumber: string = '0';
    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate: TranslateService,
        public _toaster: ToasterComponent, vcr: ViewContainerRef, public _location: Location) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.buildNumber = _global.get('BUILU_NUMBER');
        this._toaster.setViewRef(vcr);
    }

    public ngOnInit() {
        this.http.get(this._baseUrl + 'noAuth/buildNumber', { responseType: 'text' })
            .subscribe((response) => {
                this.backEndbuildNumber = response;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/superAdmin/buildDetailsComponent.ts